import React from 'react';

const CloseIcon = (props: { size: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" height={props.size} width={props.size}>
    <path
      fill="currentColor"
      d="M312.1 375c9.369 9.369 9.369 24.57 0 33.94s-24.57 9.369-33.94 0L160 289.9l-119 119c-9.369 9.369-24.57 9.369-33.94 0s-9.369-24.57 0-33.94L126.1 256L7.027 136.1c-9.369-9.369-9.369-24.57 0-33.94s24.57-9.369 33.94 0L160 222.1l119-119c9.369-9.369 24.57-9.369 33.94 0s9.369 24.57 0 33.94L193.9 256L312.1 375z"
    />
  </svg>
);

export default CloseIcon;
